var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "67px",
    viewBox: "0 0 49 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0053945%",
    y1: "8.58610612%",
    x2: "50.0053945%",
    y2: "100.013939%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.02,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "3.16804688%",
    cy: "2.71744318%",
    fx: "3.16804688%",
    fy: "2.71744318%",
    r: "161.248516%",
    gradientTransform: "translate(0.031680,0.027174),scale(1.000000,0.727273),translate(-0.031680,-0.027174)",
    id: "radialGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consumer-Apps-Sheets-Large-VD-R8-",
    transform: "translate(-451.000000, -451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hero",
    transform: "translate(0.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personal",
    transform: "translate(277.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sheets-icon",
    transform: "translate(174.833333, 89.958333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L36.9791667,10.3541667 L29.5833333,0 Z",
    id: "Path",
    fill: "#0F9D58",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8333333,31.8020833 L11.8333333,53.25 L35.5,53.25 L35.5,31.8020833 L11.8333333,31.8020833 Z M22.1875,50.2916667 L14.7916667,50.2916667 L14.7916667,46.59375 L22.1875,46.59375 L22.1875,50.2916667 Z M22.1875,44.375 L14.7916667,44.375 L14.7916667,40.6770833 L22.1875,40.6770833 L22.1875,44.375 Z M22.1875,38.4583333 L14.7916667,38.4583333 L14.7916667,34.7604167 L22.1875,34.7604167 L22.1875,38.4583333 Z M32.5416667,50.2916667 L25.1458333,50.2916667 L25.1458333,46.59375 L32.5416667,46.59375 L32.5416667,50.2916667 Z M32.5416667,44.375 L25.1458333,44.375 L25.1458333,40.6770833 L32.5416667,40.6770833 L32.5416667,44.375 Z M32.5416667,38.4583333 L25.1458333,38.4583333 L25.1458333,34.7604167 L32.5416667,34.7604167 L32.5416667,38.4583333 Z",
    id: "Shape",
    fill: "#F1F1F1",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "30.8813021 16.4520313 47.3333333 32.9003646 47.3333333 17.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.625000, -2.958333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95833333,2.95833333 L2.95833333,16.2708333 C2.95833333,18.7225521 4.94411458,20.7083333 7.39583333,20.7083333 L20.7083333,20.7083333 L2.95833333,2.95833333 Z",
    id: "Path",
    fill: "#87CEAC",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,4.80729167 C0,2.36666667 1.996875,0.369791667 4.4375,0.369791667 L29.5833333,0.369791667 L29.5833333,0 L4.4375,0 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8958333,64.7135417 L4.4375,64.7135417 C1.996875,64.7135417 0,62.7166667 0,60.2760417 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,60.2760417 C47.3333333,62.7166667 45.3364583,64.7135417 42.8958333,64.7135417 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0208333,17.75 C31.5691146,17.75 29.5833333,15.7642188 29.5833333,13.3125 L29.5833333,13.6822917 C29.5833333,16.1340104 31.5691146,18.1197917 34.0208333,18.1197917 L47.3333333,18.1197917 L47.3333333,17.75 L34.0208333,17.75 Z",
    id: "Path",
    fillOpacity: 0.1,
    fill: "#263238",
    fillRule: "nonzero",
    mask: "url(#mask-15)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5833333,0 L4.4375,0 C1.996875,0 0,1.996875 0,4.4375 L0,60.6458333 C0,63.0864583 1.996875,65.0833333 4.4375,65.0833333 L42.8958333,65.0833333 C45.3364583,65.0833333 47.3333333,63.0864583 47.3333333,60.6458333 L47.3333333,17.75 L29.5833333,0 Z",
    id: "Path",
    fill: "url(#radialGradient-16)",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheets);
export default __webpack_public_path__ + "static/media/sheets.f917fd00d2f3982180dc13d9c5ab28f1.svg";
export { ForwardRef as ReactComponent };